export const THE_OPEN_PLATFORM = 'TheOpen';
export const AIGWO_PLATFORM = 'AIGWO';
export const RANDA_PLATFORM = 'Randa';
export const FANATICS_PLATFORM = 'FanaticsShop';

// TO_DO review values here
export const THE_OPEN_CLIENT_ID_STG = '2f847gukbfgj2c44vk5ilm2lqv';
export const THE_OPEN_CLIENT_ID_DEV = '2d0a2trd059eo9sj2pfpli75sc';
export const THE_OPEN_CLIENT_ID_PROD = 'itikrg12uhktshrithi49s59v';

export const THE_OPEN_APP_CLIENT_ID_PROD = '2o2viivmokg4m8hmei17nduib3';

export const AIGWO_CLIENT_ID_STG_2 = '1i4fmv9m7tu481fes6i779gses';
export const AIGWO_CLIENT_ID_STG = '7km6l4no8dm0d42crcd24455b8';
export const AIGWO_CLIENT_ID_PROD ='4f6v6cuhfp43p8v8s0vkhrcaas';

export const RANDA_CLIENT_ID = '250cj9hgcbkb1g7ki866l0k5k7';

export const AIGWO_APP_CLIENT_ID_PROD = '41s3jh8isusl39jeoifihuh9o9';

export const RANDA_TV_CLIENT_ID_PROD = '10m5jep544s8ifak8i6qnia6ur';

export const ONE_CLUB_CLIENT_ID = '3u64mbqae9pie5hga7l02csvak';

export const FANATICS_CLIENT_ID = '4jduu58ng89r82n4ak5lt1806i';
export const FANATICS_STG_CLIENT_ID = '4isqkv5c92ggtg617afl6u86v8';

export const ClientIds: any = {
  [THE_OPEN_CLIENT_ID_STG]: THE_OPEN_PLATFORM,
  [THE_OPEN_CLIENT_ID_DEV]: THE_OPEN_PLATFORM,
  [THE_OPEN_CLIENT_ID_PROD]: THE_OPEN_PLATFORM,

  [AIGWO_CLIENT_ID_STG_2]: AIGWO_PLATFORM,
  [AIGWO_CLIENT_ID_STG]: AIGWO_PLATFORM,
  [AIGWO_CLIENT_ID_PROD]: AIGWO_PLATFORM,

  [RANDA_CLIENT_ID]: RANDA_PLATFORM,

  [AIGWO_APP_CLIENT_ID_PROD]: 'AIGWOApp',

  [RANDA_TV_CLIENT_ID_PROD]: 'RandaTV',

  [ONE_CLUB_CLIENT_ID]: 'OneClub',

  [THE_OPEN_APP_CLIENT_ID_PROD]: 'TheOpenApp',

  [FANATICS_CLIENT_ID]: FANATICS_PLATFORM,
  [FANATICS_STG_CLIENT_ID]: FANATICS_PLATFORM,
};
